import classNames from 'classnames';
import { HTMLAttributes } from 'react';

import style from './Container.module.css';

type Props = HTMLAttributes<HTMLDivElement>;

export function Container(props: Props) {
    const { className, ...restProps } = props;

    return (
        <div {...restProps} className={classNames(style.container, className)}>
            {props.children}
        </div>
    );
}
